<template>
  <div class="formData Taxi">
    <TaxiBase ref="TaxiBase" :form="form.application.cert"></TaxiBase>
    <TaxiPayment
      ref="taxiPayment"
      v-if="spCode == '00'"
      :form="form.application"
    ></TaxiPayment>
    <div class="ps_msgBox">
      <div class="ps_msg_success" v-if="spCode == 'T05'">
        <img src="../../../../assets/Success.png" alt="" />
        <div class="success_text">
          {{ $t("message.DataRegistration.Taxi.paid") }}
        </div>
      </div>
      <div class="ps_msg_failed" v-else-if="spCode != '00'">
        <div class="failed_text">
          <i class="el-icon-warning"></i>
          <span>{{ $t("message.DataRegistration.Taxi.canNotPay") }}</span>
        </div>
        <div class="failed_reason">
          {{ $t("message.DataRegistration.Taxi.reason")
          }}{{
            (form &&
              form.application &&
              form.application[
                `spResult${
                  $i18n.locale == "ZH_TW" || $i18n.locale == "ZH_CN"
                    ? "Cn"
                    : "Pt"
                }`
              ]) ||
            ""
          }}
        </div>
      </div>
    </div>
    <div class="next_btn" v-if="spCode != '00'">
      <GradientBtn @click="record()">{{
        $t("message.DataRegistration.Taxi.showRecord")
      }}</GradientBtn>
    </div>
  </div>
</template>

<script>
import TaxiBase from "../components/TaxiBase";
import TaxiPayment from "../components/TaxiPayment";
import GradientBtn from "../../../../components/GradientBtn";
export default {
  components: { TaxiBase, TaxiPayment, GradientBtn },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    spCode() {
      const form = this.form;
      return (form && form.application && form.application.spCode) || "";
    },
  },
  methods: {
    // 查看歷年繳付紀錄
    record() {
      this.$router.push("/paymentRecord");
    },
  },
  created() {
    const taxiApplication =
      JSON.parse(localStorage.getItem("taxiApplication")) || null;
    const thousand = (num) => {
      if (num) {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      }
    };
    // console.log(thousand(100000));
    if (taxiApplication) {
      if (taxiApplication.application && taxiApplication.application.cheque) {
        if (taxiApplication.application.cheque.amount)
          taxiApplication.application.cheque.amount =
            "MOP " + thousand(taxiApplication.application.cheque.amount);
        if (taxiApplication.application.cheque.taxAmount)
          taxiApplication.application.cheque.taxAmount =
            "MOP " + thousand(taxiApplication.application.cheque.taxAmount);
      }
      this.form = taxiApplication;
    }
  },
};
</script>

<style lang="scss" scoped>
.formData {
  overflow: hidden;
  max-width: 1048px;
  margin: auto;
  box-shadow: 0px 2px 7px 2px rgba(0, 0, 0, 0.16);
}
.ps_msgBox {
  max-width: 750px;
  margin: auto;
}
.ps_msg_success {
  background: #f9fef1;
  border: 1px solid #d8fba3;
  padding: 30px 15px;
  text-align: center;
  margin: auto;
  border-radius: 5px;
  .success_text {
    color: #70b606;
    font-size: 22px;
    margin-top: 20px;
  }
}
.ps_msgBox{
  padding: 0 14px;
}
.showRecord_btn {
  text-align: center;
  margin: 30px 0;
}
</style>